import { Link } from "react-router-dom";

export default function Landing() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-400 via-yellow-300 to-yellow-100 flex flex-col items-center justify-center text-center">
      <h1 className="text-5xl font-bold text-gray-800 mb-8">Welcome to Millie’s World 🌼</h1>
      <Link to="/main">
        <button className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-6 rounded-lg shadow-lg transition-all">
          Enter Site
        </button>
      </Link>
    </div>
  );
}
